import { render } from "./SovSlide.vue?vue&type=template&id=3beb5d6c"
import script from "./SovSlide.vue?vue&type=script&lang=js"
export * from "./SovSlide.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__